module.exports = __webpack_public_path__ + "static/direct-debit-4a64e4e8cf6e15cbe699c5b727d44872.png";